import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { plainToClass } from 'class-transformer';
import { BehaviorSubject, Observable, throwError } from 'rxjs';
import { catchError, map, tap, timeout } from 'rxjs/operators';
import { RestService } from 'src/app/shared/service/rest.service';
import { ReviewLabel } from '../model/review-label';
import { TenantInfo } from '../model/tenant-info';
import { SessionStorageService } from '../../common/service/session-storage.service';
import { SakpModuleUtils } from '../sakp-module-utils';


@Injectable()
export class ReviewLabelService extends RestService {
    public static readonly SOURCE = 'review-labels';
    private static readonly STORAGE_NAME = 'sakp-review-labels';
    private dataSubject: BehaviorSubject<ReviewLabel[]> = new BehaviorSubject([]);


    constructor(http: HttpClient, private sessionStorageService: SessionStorageService) {
        super(http);
        this.serverUrl = SakpModuleUtils.getSakpServerUrl();
        const data = this.sessionStorageService.getItemArray<ReviewLabel>(ReviewLabelService.STORAGE_NAME, ReviewLabel);
        if (data != null)
            this.dataSubject.next(data);
    }

    initiate(tenant: TenantInfo): Observable<ReviewLabel[]> {
        // eslint-disable-next-line @typescript-eslint/naming-convention
        return this.doGet('api/v1/dict/labels', null, { 'X-Tenant-ID': tenant.id.toString() })
            .pipe(
                timeout(5000),
                map((res: any[]) => plainToClass(ReviewLabel, res)),
                tap(data => {
                    this.dataSubject.next(data);
                    this.sessionStorageService.setItem(ReviewLabelService.STORAGE_NAME, data);
                }),
                catchError(err => {
                    this.dataSubject.next([]);
                    this.sessionStorageService.setItem(ReviewLabelService.STORAGE_NAME, []);
                    err.source = ReviewLabelService.SOURCE;
                    return throwError(err);
                })
            );
    }

    getAll(): ReviewLabel[] {
        return this.dataSubject.getValue() || [];
    }

    clear(): void {
        this.sessionStorageService.setItem(ReviewLabelService.STORAGE_NAME, []);
        this.dataSubject.next([]);
    }

}
